import { render, staticRenderFns } from "./phoneExamineTable.vue?vue&type=template&id=6dcefa1a&scoped=true"
import script from "./phoneExamineTable.vue?vue&type=script&lang=ts"
export * from "./phoneExamineTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcefa1a",
  null
  
)

export default component.exports